module.exports = __webpack_public_path__ + "static/Irriglobe_Produits-1063ebd45341d8d5dd1ff03102abeaf5.webm";